import { render } from "./smartOilUpload.vue?vue&type=template&id=36daa13c&scoped=true"
import script from "./smartOilUpload.vue?vue&type=script&lang=js"
export * from "./smartOilUpload.vue?vue&type=script&lang=js"

import "./smartOilUpload.vue?vue&type=style&index=0&id=36daa13c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36daa13c"]])

export default __exports__